<template>
  <div>
    <PlainButton
      class="chatbot-closet text-white px-lgp py-md p-lg-sm shadow-secondary"
      :class="type"
      @click="chatbotDrawer.open()">
      <ConversationalSearchIcon/>
      <div :class="{'ms-xxs' : !isTile}">
        <h4 class="mb-xs">
          {{ greetingMessage }} 
        </h4>
        <p class="mb-xs">
          {{ greetingQuestion }}
        </p>
        <BaseLink
          text="Let's chat"
          variant="text-link-light"
          class="text-decoration-underline text-white"
          @click="chatbotDrawer.open()"/>
      </div>
    </PlainButton>
  </div>
</template>
  
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useDrawers } from '@/composables/drawers.js'
import { useStylingChatbotStore } from '@/stores/stylingChatbot.js'
import ConversationalSearchIcon from '@shared/components/icons/ConversationalSearchIcon.vue'
import PlainButton from '@/components/global/sequin/PlainButton.vue'
import BaseLink from '@shared/components/BaseLink.vue'

const props = defineProps({
  type: {
    type: String,
    validator: (value) => ['tile', 'section'].includes(value),
    default: 'tile'
  }
})

const { chatbotDrawer } = useDrawers()
const { greetingMessage, greetingQuestion } = storeToRefs(useStylingChatbotStore())

const isTile = computed(() => props.type === 'tile')

</script>

<style lang="scss" scoped>
@import '@shared/components/ADORN/PreviewImage.scss';
.chatbot-closet {
  border-radius: $sequin-border-radius;
  background-color: $teal;
  color: $white !important;
  p {
    line-height: 20px;
  }
}
.chatbot-closet.tile {
  padding: 0 $spacing-sm;
  aspect-ratio: #{$image-aspect-ratio} !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.chatbot-closet.section {
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  svg {
    width: 64px !important;
    height: 64px !important;
  }
  @media (min-width: 450px) {
  svg {
    width: 96px;
    height: 96px;
  }
  }
}
</style>